export default __webpack_public_path__ + "static/media/IMG_6417.8c6aa468.jpeg";